import { IPEActionTypes } from "../../action-types/tkb/IPEActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IPEReducer } from "../../reducer-model/tkb/IPEReducer";

const iniState: IPEReducer = {
    status: eReducerStatusBase.is_not_initialization,
    lopTinChis: [],
    suKiens: [],
    phamVis: [],
    filter: {
        hoc_ky: 0,
        id_chuyen_nganh: 0,
        id_he: 0,
        khoa_hoc: 0,
        ky_dang_ky: 0,
        nam_hoc: "",
        stu_nhomlop_ids: [],
        id_nganh: 0,
        pl_giaidoan_id: 0,
        id_bm: 20,
        id_mon: 0
    },
    trungConflict: undefined,
    isShowModal: false,
    editing: undefined
}

export const peReducer = (state: IPEReducer = iniState, action: IPEActionTypes): IPEReducer => {
    switch (action.type) {
        case "PE_CHANGE_FILTER":
            return { ...state, filter: action.payload }
        case "PE_LOAD_LIST_START":
            return { ...state, status: eReducerStatusBase.is_loading }
        case "PE_LOAD_LIST_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lopTinChis: action.payload.lopTinChis,
                suKiens: action.payload.suKiens,
                phamVis: action.payload.phamVis ?? []
            }
        case "PE_LOAD_LIST_ERRR":
            return { ...state, status: eReducerStatusBase.is_completed }
        case "PE_OPEN_MODAL":
            return { ...state, isShowModal: true, editing: action.payload }
        case "PE_CLOSE_MODAL":
            return { ...state, isShowModal: false, editing: undefined }
        case "PE_CREATE_START":
        case "PE_CREATE_MULTIPLE_START":
        case "PE_UPDATE_START":
        case "PE_DELETE_START":
        case "PE_DELETE_MULTIPLE_START":
        case "PE_UPDATE_IDLOPS_START":
        case "PE_UPDATE_PHAMVI_NHOMLOP_START":
            return { ...state, status: eReducerStatusBase.is_saving }
        case "PE_CREATE_SUCCESS":
        case "PE_UPDATE_SUCCESS":
        case "PE_CREATE_ERRR":
        case "PE_UPDATE_ERRR":
        case "PE_DELETE_SUCCESS":
        case "PE_DELETE_ERRR":
        case "PE_UPDATE_IDLOPS_SUCCESS":
        case "PE_UPDATE_IDLOPS_ERRR":
        case "PE_UPDATE_PHAMVI_NHOMLOP_SUCCESS":
        case "PE_UPDATE_PHAMVI_NHOMLOP_ERRR":
            return { ...state, status: eReducerStatusBase.is_completed }
        case "PE_UPDATE_SUKIEN_SUCCESS": {
            // Patch sự kiện theo id (server trả các sự kiện bị ảnh hưởng, kể cả cascade 2 giai đoạn).
            const suKiensNew = [...state.suKiens];
            action.payload.forEach(sk => {
                const idx = suKiensNew.findIndex(x => x.id === sk.id);
                if (idx >= 0) {
                    suKiensNew[idx] = {
                        ...suKiensNew[idx],
                        ...sk,
                        // Dùng || (không phải ??): tránh ten_lop_hp = "" từ server ghi đè tên cũ.
                        ten_lop_hp: sk.ten_lop_hp || suKiensNew[idx].ten_lop_hp
                    }
                } else {
                    suKiensNew.push(sk);
                }
            })
            return { ...state, status: eReducerStatusBase.is_completed, suKiens: suKiensNew, trungConflict: undefined }
        }
        case "PE_UPDATE_SUKIEN_TRUNG":
            return { ...state, trungConflict: action.payload }
        case "PE_UPDATE_SUKIEN_ERRR":
            return { ...state, status: eReducerStatusBase.is_completed }
        default:
            return { ...state };
    }
}
